import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=4ddd82ea&scoped=true&"
import script from "./VFooter.vue?vue&type=script&lang=ts&"
export * from "./VFooter.vue?vue&type=script&lang=ts&"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=4ddd82ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd82ea",
  null
  
)

export default component.exports